import Etsy from "../assets/Etsy_logo 1.svg";
import Depop from "../assets/depop.svg";
import Poshmark from "../assets/poshmark.svg";
import Goat from "../assets/GOAT_logo.jpg";
import Shopify from "../assets/Shopify_logo.svg";
import Stocks from "../assets/stockx.svg";
import Facebook from "../assets/Facebook-f_Logo-Blue-Logo.wine.svg";
import Grailed from "../assets/Grailed.png";
import Mercari from "../assets/Mercari_logo_2018.svg.png";
import Vinted from "../assets/vinted-marketplace-logo.png";
import offerup from "../assets/offerup.png";
import Instagram from "../assets/IG.png";
import EBay from "../assets/EBay_logo.svg";


export const platforms = [
  {
    PlatformType: "Etsy",
    PlatformTypeImg: Etsy,
  },
  {
    PlatformType: "Depop",
    PlatformTypeImg: Depop,
  },
  {
    PlatformType: "Poshmark",
    PlatformTypeImg: Poshmark,
  },
  {
    PlatformType: "GOAT",
    PlatformTypeImg: Goat,
  },
  {
    PlatformType: "Shopify",
    PlatformTypeImg: Shopify,
  },
  {
    PlatformType: "StockX",
    PlatformTypeImg: Stocks,
  },
  {
    PlatformType: "Facebook Marketplace",
    PlatformTypeImg: Facebook,
  },
  {
    PlatformType: "Grailed",
    PlatformTypeImg: Grailed,
  },
  {
    PlatformType: "Mercari",
    PlatformTypeImg: Mercari,
  },
  {
    PlatformType: "Vinted",
    PlatformTypeImg: Vinted,
  },
  {
    PlatformType: "OfferUp",
    PlatformTypeImg: offerup,
  },
  {
    PlatformType: "Instagram",
    PlatformTypeImg: Instagram,
  },
  {
    PlatformType: "eBay",
    PlatformTypeImg: EBay,
  },
];
